import { cn } from '../../lib/cn';

export default function ThinkingIndicator({
  message = 'Reading your responses...',
  className,
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-16',
        className
      )}
    >
      <div className="relative w-16 h-16 mb-6">
        {/* Animated dots */}
        <div className="absolute inset-0 flex items-center justify-center gap-2">
          <span className="w-3 h-3 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce [animation-delay:-0.3s]" />
          <span className="w-3 h-3 bg-gray-500 dark:bg-gray-400 rounded-full animate-bounce [animation-delay:-0.15s]" />
          <span className="w-3 h-3 bg-gray-600 dark:bg-gray-300 rounded-full animate-bounce" />
        </div>
        {/* Glow effect */}
        <div className="absolute inset-0 bg-gray-200 dark:bg-gray-700 rounded-full blur-xl opacity-50 animate-pulse" />
      </div>
      <p className="text-gray-600 dark:text-gray-400 font-medium">{message}</p>
    </div>
  );
}

export function ThinkingIndicatorInline({ className }) {
  return (
    <span className={cn('inline-flex items-center gap-1', className)}>
      <span className="w-1.5 h-1.5 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce [animation-delay:-0.3s]" />
      <span className="w-1.5 h-1.5 bg-gray-500 dark:bg-gray-400 rounded-full animate-bounce [animation-delay:-0.15s]" />
      <span className="w-1.5 h-1.5 bg-gray-600 dark:bg-gray-300 rounded-full animate-bounce" />
    </span>
  );
}

export function ThinkingIndicatorBar({ className }) {
  return (
    <div className={cn('h-1 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden', className)}>
      <div className="h-full w-1/3 bg-gradient-to-r from-gray-400 to-gray-600 dark:from-gray-500 dark:to-gray-300 rounded-full animate-[shimmer_1.5s_ease-in-out_infinite]" />
      <style>{`
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(400%); }
        }
      `}</style>
    </div>
  );
}
